import React, { useState, useEffect, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, Navigate, useParams } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import LinearProgress from '@mui/material/LinearProgress';
import axios from 'axios';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import uuid from 'react-uuid';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import LanguageIcon from '@mui/icons-material/Language';
import TranslateIcon from '@mui/icons-material/Translate';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import { LocalizationContext } from '../App';

const LoupeActivityByCode = props => {

    const localizer = useContext(LocalizationContext);
    

    const navigate = useNavigate();

    const { activityCode } = useParams();
    
    const [ currentActivity, setCurrentActivity ] = React.useState(0);
    const [ showPosLoader, setShowPosLoader ] = React.useState(false);
    const [ alternativeLanguages, setAlternativeLanguages ] = React.useState(0);
    const [ currentLanguage, setCurrentLanguage ] = React.useState(localizer.getLanguage());
    const [ activityLanguage, setActivityLanguage ] = React.useState(localizer.getLanguage());

    const [ isValid, setIsValid ] = useState(-1);
    const [ isApproved, setIsApproved ] = useState(false);
    const [ isOpen, setIsOpen] = React.useState(false);

    const defLang = localizer.getInterfaceLanguage();
    
    

    const NavigateToActivity = () => {        
        locateUser();
    }


    const changeActivityLanguage = key => {
        setIsOpen(false); // rename to own scope
        setActivityLanguage(key);
    }

    const changeInterfaceLanguage = key => {
        localizer.setLanguage(key);
        setIsOpen(false);
        setCurrentLanguage(key);
    }

    const retrieveActivity = (language, code) => {
        retrieveActivityDetails(language, code);
        retrieveAlternativeLanguages(code);
    }

    
    const [state, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const retrieveIsValidActivity = (code) => {

        let uri = process.env.REACT_APP_SERVICE_URI + '/api/isValidCode/' + code;      
        axios.get(uri, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            if(res.data == 'TRUE') {
                setIsValid(1);
                retrieveActivity( activityLanguage, activityCode);
            } else {
                setIsValid(0);
            }   

        }).catch(error => {
            console.log(error);
        });
    }

    const handleApproval = (event) => {
        setIsApproved(event.target.checked);
    };

    const retrieveActivityDetails = (lang, code) => {
                
        let uri = process.env.REACT_APP_SERVICE_URI + '/api/getActivityByCode/' + lang + '/' + code;                
        axios.get(uri, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            if(Array.isArray(res.data)  && (res.data).length > 0) {
                setCurrentActivity(res.data[0]);
            } else {
                 setCurrentActivity(-1);
            }
        
        }).catch(error => {
            console.log(error);
        });
    }

    const retrieveAlternativeLanguages = (code) => {
       
        let uri = process.env.REACT_APP_SERVICE_URI + '/api/getAvailableLanguageCodesForActivity/' + code;                
        axios.get(uri, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            if(Array.isArray(res.data) && (res.data).length > 0) {
                setAlternativeLanguages(res.data)
            } else {
                setAlternativeLanguages(-1);
            }
        
        }).catch(error => {
            console.log(error);
        });
    }

    
    const locateUser = () => {
        setShowPosLoader(true);
        if ("geolocation" in navigator) {            
            navigator.geolocation.getCurrentPosition(
                (position) => { 
                    currentActivity['latitude'] = position.coords.latitude;
                    currentActivity['longitude'] = position.coords.longitude;
                    currentActivity['accuracy'] = position.coords.accuracy;                    
                    currentActivity['source'] = 'code';
                    currentActivity['sessionId'] = uuid();
                    navigate('/activity-content/' + activityLanguage + "/" + activityCode, { replace : true, state : { activity : currentActivity } } );
                },
                () => {
                    currentActivity['latitude'] = null;
                    currentActivity['longitude'] = null;
                    currentActivity['accuracy'] = null;                    
                    currentActivity['source'] = 'code';
                    currentActivity['sessionId'] = uuid();
                    navigate('/activity-content/' + activityLanguage + "/" + activityCode, { replace : true, state : { activity : currentActivity } } );
                },
                { timeout : 10000 }            
            );
        } else {
            currentActivity['latitude'] = null;
            currentActivity['longitude'] = null;
            currentActivity['accuracy'] = null;                    
            currentActivity['source'] = 'code';
            currentActivity['sessionId'] = uuid();
            navigate('/activity-content/' + activityLanguage + "/" + activityCode, { replace : true, state : { activity : currentActivity } } );
        }
    }


    useEffect(() => {
        retrieveIsValidActivity(activityCode);
    }, [currentLanguage, activityLanguage]);



    return (

        <LocalizationContext.Consumer>
            { ({strings, setLanguage}) => 

                <div className="padding">

                    { isValid == -1 &&
                        <div><LinearProgress /></div>
                    }
                    { isValid == 0 &&
                        <div>{strings.getString("errors.activity.invalidcode.message")}</div>
                    }
                    { isValid == 1 &&
                        <div>
                    
                        { currentActivity == -1 &&
                            <div>{strings.getString("messages.activity.otherlanguage")}</div>
                        }

                        { currentActivity == 0 &&
                            <LinearProgress />
                        }

                        { (currentActivity != 0 && currentActivity != -1 && showPosLoader == false ) && 
                            <div>
                                <div className="mb-4 text-start">

                                    <Card className="mb-2" raised={false} elevation={0}>
                                        <CardContent>
                                            <Typography variant="h6" className="text-start">{currentActivity.Title}</Typography>               
                                        </CardContent>
                                    </Card> 

                                    <Card className="mb-2" raised={false} elevation={0}>
                                        <CardContent>
                                            <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.abstract")}</Typography>  
                                            <Typography variant="body2" className="text-start">{currentActivity.Abstract}</Typography>               
                                        </CardContent>
                                    </Card> 

                                    <Card className="mb-2" raised={false} elevation={0}>
                                        <CardContent>
                                            <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.contact")}</Typography>  
                                            <Typography variant="body2" className="text-start">{currentActivity.PointOfContact}</Typography>               
                                        </CardContent>
                                    </Card>             

                                    <Card className="mb-2" raised={false} elevation={0}>
                                        <CardContent>
                                            <Typography color="text.secondary" variant="subtitle1" className="fw-lighter text-start">{strings.getString("texts.details.keywords")}</Typography>  
                                            <Typography variant="body2" className="text-start">{currentActivity.Keywords}</Typography>               
                                        </CardContent>
                                    </Card>

                                    <Divider className="mb-4"/>
                                    <div className="mb-3">
                                        <FormGroup>
                                            <FormControlLabel 
                                                control={<Switch checked={isApproved} onChange={handleApproval} />} 
                                                label={
                                                <>
                                                    <Typography variant="body2" gutterBottom component="span">{strings.getString("texts.activity.consent")}</Typography>
                                                </>} />
                                        </FormGroup>
                                    </div>

                                </div>
                                
                                <div>
                                
                                <Button 
                                    {...(isApproved == true ? {} : {disabled : true})}
                                    onClick={NavigateToActivity}>{strings.getString("controls.buttons.activity.start")}
                                </Button>
                            
                                </div>
                            </div>
                        }

                        { (currentActivity != 0 && currentActivity != -1 && showPosLoader == true ) && 
                            <div>
                                <div className="mb-4">
                                    <CircularProgress />
                                </div>
                            </div>
                        }

                        { ((currentActivity == -1 || currentActivity != 0) && showPosLoader == false ) && 
                            <div>                                
                                { alternativeLanguages != 0 &&
                                    <div>

                                        <div className="mb-4" />
                                            <Button onClick={() => setIsOpen(true)} color={ (currentActivity != 0 && currentActivity != -1 && showPosLoader == false ) ? 'primary' : 'primary' } >
                                                <>
                                                    <TranslateIcon className="padright"/>
                                                    {strings.getString("controls.buttons.activity.language.change")}
                                                </>
                                            </Button> 
                                        <br />

                                        <Divider className="padtop padbottom"/>
                                        <Button onClick={() => navigate('/')}>{strings.getString("controls.buttons.activity.home")}</Button>


                                        <Dialog open={isOpen}>
                                            <DialogTitle>{strings.getString("dialogs.language.selection.title")}</DialogTitle>
                                            <List sx={{ pt: 0 }}>
                                            { alternativeLanguages.map(l => {
                                                    var clang = l['activity_language'];
                                                    return(
                                                        <ListItem button key={clang}>
                                                            <ListItemText onClick={() => changeActivityLanguage(clang)} primary={strings.getString("texts.languages.names." + clang)}/>
                                                        </ListItem>
                                                    )
                                                })}

                                        	<Divider />
                                            <ListItem button key={'cancel_language_selection'}>
                                                <ListItemText onClick={() => setIsOpen(false)} primary={strings.getString("controls.buttons.cancel")}/>
                                            </ListItem>

                                            </List>
                                        </Dialog>
                                    </div>
                                }
                            </div>
                        }

                        </div>

                    }

                </div>

               
            }
        </LocalizationContext.Consumer>
    )

}
export default LoupeActivityByCode;